import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translateEn from './en-US.json'
import translateZh from './zh-CN.json'
import translateJa from './ja-JP.json'
import translateCs from './cs.json'
import translateEs from './es.json'
import translateIt from './it.json'
import translateAr from './ar.json'
import translateVi from './vi.json'
import translateTh from './th.json'
import translateKo from './ko.json'

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: translateEn
    },
    zh: {
      translation: translateZh
    },
    ja: {
      translation: translateJa
    },
    cs: {
      translation: translateCs
    },
    es: {
      translation: translateEs
    },
    it: {
      translation: translateIt
    },
    ar: {
      translation: translateAr
    },
    vi: {
      translation: translateVi
    },
    th: {
      translation: translateTh
    },
    ko: {
      translation: translateKo
    }
  }
})

export default i18n
